import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

/// Material
import { MatTabsModule} from '@angular/material/tabs';
import { MatButtonModule} from '@angular/material/button';
import { MatCardModule} from '@angular/material/card';
import { MatIconModule} from '@angular/material/icon';
import { MatSelectModule} from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule} from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule} from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule} from '@angular/material/dialog';

// Directives
import { DynamicPlaceholderDirective } from './directives/dynamic-placeholder.directive';

// Components
import { MapComponent } from './components/map/map.component';
import { PopularComponent } from './components/popular/popular.component';
import { TwitterComponent } from './components/twitter/twitter.component';
import { FeedComponent } from './components/feed/feed.component';
import { CategoriesComponent } from './components/categories/categories.component';
import { ArticlesComponent } from './components/articles/articles.component';
import { ArticlessidenavComponent } from './components/articlessidenav/articlessidenav.component';
import { WeeklyChartComponent } from './components/weekly-chart/weekly-chart.component';
import { ArticlesMapComponent } from './components/articles-map/articles-map.component';
import { ReferencesComponent } from './components/references/references.component';
import { DialogMapComponent } from './components/dialog-map/dialog-map.component';



@NgModule({
  declarations: [
    AppComponent,
    MapComponent,
    PopularComponent,
    TwitterComponent,
    FeedComponent,
    CategoriesComponent,
    ArticlesComponent,
    ArticlessidenavComponent,
    WeeklyChartComponent,
    ArticlesMapComponent,
    DynamicPlaceholderDirective,
    ReferencesComponent,
    DialogMapComponent
    ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    MatTabsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatSelectModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatListModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatGridListModule,
    MatRadioModule,
    MatInputModule,
    MatDialogModule
    ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [DialogMapComponent]
})
export class AppModule { }
